<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon bg-mean-fruit rounded-circle"><i class="pe-7s-id text-white"></i></div>
        <div>
          Manage Roles
          <div class="page-title-subheading">Define roles and the menus/pages each one can see.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="mb-3 card">
        <div class="card-header d-flex justify-content-between align-items-center">
          Roles
          <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#roleModal" (click)="openAddModal()">
            <i class="fa fa-plus mr-1"></i> Add Role
          </button>
        </div>
        <div class="card-body">
          <div *ngIf="loading" class="text-center py-5">
            <span class="spinner-border text-primary"></span>
          </div>
          <vio-table-v2 *ngIf="!loading" [tableData]="tableData" [tableConfig]="tableConfig"></vio-table-v2>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Role modal -->
  <div class="modal fade" id="roleModal" tabindex="-1" aria-hidden="true" appAppendToBody>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ operation === 'Add' ? 'Add Role' : 'Edit Role' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Role Name</label>
            <input
              class="form-control"
              placeholder="e.g. Quality Lead"
              autocomplete="off"
              [(ngModel)]="roleNameInput"
              [disabled]="operation === 'Edit'"
            />
            <small class="text-muted" *ngIf="operation === 'Edit'">Role name can't be changed after creation.</small>
          </div>
          <div class="form-group mb-0">
            <div class="d-flex justify-content-between align-items-center">
              <label class="mb-0">Visible Menus &amp; Pages</label>
              <div class="fn-bulk-actions">
                <button type="button" class="fn-bulk-btn" (click)="selectAllFunctionalities()">All</button>
                <span class="fn-bulk-sep">/</span>
                <button type="button" class="fn-bulk-btn" (click)="selectNoFunctionalities()">None</button>
              </div>
            </div>
            <div class="fn-grid">
              <label class="fn-chip" [class.selected]="isSelected(fn.fncode)" *ngFor="let fn of allFunctionalities">
                <input class="fn-chip-input" type="checkbox" [checked]="isSelected(fn.fncode)" (change)="toggleFunctionality(fn.fncode)" />
                <i class="fn-chip-icon" [class]="iconFor(fn.fnname)"></i>
                <span class="fn-chip-label">{{ fn.fnname }}</span>
                <i class="fa fa-check fn-chip-check"></i>
              </label>
            </div>
            <small class="text-muted fn-selected-count">{{ selectedFncodes.size }}/{{ allFunctionalities.length }} selected</small>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #roleModalCloseBtn>Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveRole()">
            {{ operation === 'Add' ? 'Add Role' : 'Save Changes' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
